export default __webpack_public_path__ + "static/media/snape-clap.e916b14a.gif";